import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Box from "@material-ui/core/Box";
import { Controller, useForm } from "react-hook-form";
import {
  PlayDescriptionInput,
  PLAY_DESCRIPTION_MAX_LEN,
} from "../../../../models/play";
import { requiredMessage, maxLengthRule } from "../../../../utils/form";

const useStyles = makeStyles(
  (theme: import("@material-ui/core/styles").Theme) => ({
    container: {
      marginTop: theme.spacing(3),
    },
    buttons: {
      marginTop: theme.spacing(3),
      textAlign: "right",
      "& > * + *": {
        marginLeft: theme.spacing(1),
      },
    },
    listForm: {
      width: "100%",
    },
  })
);

type Props = {
  defaultValues: PlayDescriptionInput;
  onSave: (data: PlayDescriptionInput) => void;
  onCancel: () => void;
  isSaving: boolean;
  saveError?: string;
};

export default function Form({
  defaultValues,
  onSave,
  onCancel,
  isSaving,
  saveError,
}: Props) {
  const classes = useStyles();

  const { handleSubmit, control } = useForm<PlayDescriptionInput>({
    defaultValues,
  });

  return (
    <form onSubmit={handleSubmit(onSave)}>
      {saveError && <Typography color="error">{saveError}</Typography>}
      <div className={classes.container}>
        <Controller
          name="description"
          control={control}
          rules={{
            required: requiredMessage,
            maxLength: maxLengthRule(PLAY_DESCRIPTION_MAX_LEN),
          }}
          render={({ field, fieldState: { error } }) => (
            <>
              <TextField
                fullWidth
                multiline
                minRows={4}
                label="概要"
                error={!!error}
                helperText={error?.message}
                variant="outlined"
                {...field}
              />
              <Box display="flex" justifyContent="flex-end">
                <Typography variant="body2">{`${
                  Array.from(field.value).length
                }/${PLAY_DESCRIPTION_MAX_LEN}`}</Typography>
              </Box>
            </>
          )}
        />
      </div>
      <div className={classes.buttons}>
        <Button
          size="small"
          variant="contained"
          disabled={isSaving}
          onClick={onCancel}
        >
          キャンセル
        </Button>
        <Button
          size="small"
          color="primary"
          variant="contained"
          type="submit"
          disabled={isSaving}
        >
          保存
        </Button>
      </div>
    </form>
  );
}
